import { Point } from '../../../shared/types/mathTypes.ts';
import { getManualMeasurementVariants, ManualMeasurementVariant } from '../../../shared/utils/getManualMeasurementVariants.ts';
import { Protocol } from '../../types/sharedTypeImpl.ts';
import { ContextMenu, MenuItem } from '../contextMenu.tsx';


interface Props {
    screenCoords: Point;
    protocol: Protocol;
    onVariantSelect: (protocol: Protocol, variant: ManualMeasurementVariant) => void;
    onClose: () => void;
}

export function MeasurementContextMenu({
    screenCoords,
    protocol,
    onVariantSelect,
    onClose,
}: Props) {

    const menuItems: MenuItem[] = getManualMeasurementVariants(protocol.measurementPlan).map(variant => ({
        text: `${variant} measurement`,
        callback: () => onVariantSelect(protocol, variant),
    }));

    return (
        <ContextMenu
            isOpen={true}
            position={screenCoords}
            items={menuItems}
            close={onClose}
        />
    );
}
